import { client } from '../default.client';
import { getBillAdapter } from '../adapters/bill';
import type { ApiProxyResponse } from '../types/interfaces';
import type { AxiosResponse } from 'axios';
import type { IBillDetails } from '@/types/interfaces/orders';
import type {
	IBill,
	IFilialToken,
	BillPreorderPayload,
	IPreorder
} from '@/types/interfaces/bill';
import { TARGET } from '@/types/enums/common/target';
import { MENU_TYPE } from '@/types/enums/common';

const V2_RECEIPT_MENU_TYPES: number[] = [MENU_TYPE.RKEEPER, MENU_TYPE.POSTER];

// includes сравнивает строго; Number() — чтобы '7' строкой шёл туда же, куда 7
const isV2Receipt = (target?: string, menuType?: number) =>
	target === TARGET.PLUGIN.toString() ||
	V2_RECEIPT_MENU_TYPES.includes(Number(menuType));

export const bill = {
	async getBillDetails(preorderId: string | number): Promise<IBillDetails> {
		const response = await client.get<AxiosResponse<IBill>>(
			`/smart-receipt/v1/receipt/preorder/${preorderId}`
		);

		return getBillAdapter(response.data.data);
	},
	async getBill(
		tableId: string,
		terminalId: string,
		target: string,
		menuType: number
	): Promise<IBillDetails> {
		if (isV2Receipt(target, menuType)) {
			const response = await client.get<AxiosResponse<IBill>>(
				'smart-receipt/v2/receipt',
				{
					params: {
						table_id: tableId,
						terminal_id: terminalId,
						target: target,
						menu_type: menuType
					}
				}
			);

			return getBillAdapter(response.data.data);
		}
		const response = await client.get<AxiosResponse<IBill>>(
			`smart-receipt/v1/receipt`,
			{
				params: {
					table_id: tableId,
					terminal_id: terminalId
				}
			}
		);

		return getBillAdapter(response.data.data);
	},
	async getFilialToken(filialId: string | number) {
		const response = await client.get<ApiProxyResponse<IFilialToken>>(
			`partner/filial/pure/${filialId}`
		);

		return response.data;
	},
	async createPreorder(
		payload: BillPreorderPayload,
		idempotencyKey?: string
	): Promise<ApiProxyResponse<IPreorder>> {
		const headers = idempotencyKey
			? { 'X-Idempotency-key': idempotencyKey }
			: undefined;

		if (isV2Receipt(payload.target, payload.menu_type)) {
			const response = await client.post(
				'smart-receipt/v3/receipt/preorder',
				payload,
				{ headers }
			);

			return response.data;
		}

		const response = await client.post(
			'smart-receipt/v1/receipt/preorder',
			payload,
			{ headers }
		);

		return response.data;
	}
};
